import * as React from 'react';

import { CatalogAdminEditionClientProvider } from '@/api/catalog-client-context';
import { HttpCatalogAdminEditionClient } from '@/api/catalog-edition-client.http';
import { CatalogUploadScreen } from '@/routes/admin/catalog/catalog-upload-screen';

// =============================================================================
// catalog-upload-route.tsx — Adaptateur routeur de l'upload Excel A-10 (S9-D4 ; câblé HTTP S20).
// =============================================================================
// Route `/admin/catalog/uploads` (MONDE ADMIN d'ÉCRITURE, P-05, distincte des lectures S8).
// Le BC catalog AUTO-PORTE son DI seam d'écriture : la route enveloppe l'écran avec le
// CatalogAdminEditionClientProvider. Depuis S20 (DEC-S20-B2), la route injecte l'adaptateur HTTP
// RÉEL (uploadDryRun / confirmUpload / cancelUpload contre l'API) au lieu du stub par défaut — c'est
// ce qui rend ST-UPLOAD-01 (E2E) vert. Les tests de composant continuent d'injecter le stub via la
// prop `client`. Le dry-run NE crée AUCUNE version ; la DRAFT n'est produite qu'à la confirmation
// explicite (autorité API). NB : la route d'édition profil/matrice reste stub-first (seam S8/S9).

// Instance module-level (une seule par session SPA) — parité `defaultCampaignClient`, évite de
// recréer un client à chaque render.
const catalogUploadClient = new HttpCatalogAdminEditionClient();

export function CatalogUploadRoute(): React.JSX.Element {
  return (
    <CatalogAdminEditionClientProvider client={catalogUploadClient}>
      <CatalogUploadScreen />
    </CatalogAdminEditionClientProvider>
  );
}
